"use strict";

module.exports = {
  'name': 'abs',
  'category': 'Arithmetic',
  'syntax': ['abs(x)'],
  'description': 'Compute the absolute value.',
  'examples': ['abs(3.5)', 'abs(-4.2)'],
  'seealso': ['sign']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/arithmetic/abs.js
// module id = 824
// module chunks = 0